import type { CreativeCredit } from 'sr-types/lib/shortlist/v1/graphql';

/** Nullable GraphQL list → strict array for grid / editor state. */
export function coerceKeyCreditsList(
    credits: ReadonlyArray<CreativeCredit | null | undefined> | null | undefined
): CreativeCredit[] {
    if (!Array.isArray(credits)) return [];
    return credits.filter((credit): credit is CreativeCredit => Boolean(credit));
}
